import React, { useEffect, useRef, useState } from 'react'
import { cards, categories } from '../data/cardInfo'
import _ from 'lodash'
import classNames from 'classnames'
import { Button, Wrapper } from './StartPage'
import QuizCard from './QuizCard'
import QuizAnswer from './QuizAnswer'
import styled from 'styled-components'
import QuizAnimation from './QuizAnimation'

const QuizQuestion = ({question, questionType, answers, checkAnswer}) => {

  const [selectedAnswer, setSelectedAnswer] = useState()
  const [animating, setAnimating] = useState(false)
  
  const [questionRect, setQuestionRect] = useState({})
  const [answerRect, setAnswerRect] = useState({})
  const questionRef = useRef()
  const [animationData, setAnimationData] = useState({})

  const chooseAnswer = () => {
    
    const answer = answers[selectedAnswer]
    const correct = answer === question

    if (animating) {
      checkAnswer(correct)
      setAnimating(false)
      setSelectedAnswer(null)
      setAnimationData({})
      return
    }
    setAnimating(true)
    setAnimationData({
      questionElement: questionRef,//document.querySelector('.question .card-main'),
      answerElement: document.querySelector('.answer-wrapper.selected .card-main'),
      questionInfo: question,
      answerInfo: answer,
      questionType: questionType,
      correct: correct
    })
    
    setTimeout(() => {
      checkAnswer(correct)
      setAnimating(false)
      setSelectedAnswer(null)
      setAnimationData({})
      // setAnimationStep()
    }, 2500)
  }

  return (
    <div className={classNames('question-wrapper', {animating})}>
      
      <div className={classNames('question')}>
      {question && <QuizCard ref={questionRef} animationData={animationData} animating={animating} cardData={question} questionType={questionType} question />}
      </div>
      <div className='answers' >
        {answers && answers.map((card,index) => {
          const selected = selectedAnswer === index
          const select = () => setSelectedAnswer(index)
          const deselect = () => setSelectedAnswer(null)

          return (
            <QuizAnswer animationData={animationData} animating={animating} key={index} card={card} questionType={questionType} selected={selected} select={select} deselect={deselect} />
          )
        })}
      </div>
      {selectedAnswer !== null && selectedAnswer !== undefined && 
        <Button onClick={chooseAnswer} color={categories[0].topColor} >Välj</Button>
      }
    </div>
  )
}

export default QuizQuestion